const FraudIncidentStatus = {
    PENDING : "PENDING",
    RESOLVED: "RESOLVED",
    ALL:"ALL"
};
const FraudRulesStatusMap = {
    ENABLED: {
        status:"ENABLED",
        text: "Enable",
        color: "success",
        textColor:"text-success",
        buttonColor:"outline-success"
    },
    DISABLED: {
        status:"DISABLED",
        text: "Disable",
        color: "warning",
        textColor:"text-warning",
        buttonColor:"outline-warning"
    }
}
const FraudMainTabs = {
    FRAUD_RULES: "fraudRules",
    FRAUD_INCIDENTS: "fraudIncidents",
};

export {
    FraudIncidentStatus,
    FraudRulesStatusMap,
    FraudMainTabs
}